import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import {
  type CreateNoticeMessage,
  type DeleteNoticeMessage,
  isCreateNoticeMessage,
  isDeleteNoticeMessage,
} from '@module/types/centrifuge/public-message/etcMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class CreateNoticeHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<CreateNoticeMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isCreateNoticeMessage(payload);
  }

  handle(payload: CreateNoticeMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setSupporterNotice?.(payload.data.message);
  }
}

export class DeleteNoticeHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<DeleteNoticeMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isDeleteNoticeMessage(payload);
  }

  handle(payload: DeleteNoticeMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setSupporterNotice?.('');
  }
}
